import React, { useEffect, useState, useContext } from "react";
import { Table, Spinner, Alert, Container, Card, Button, Badge, Form, InputGroup } from "react-bootstrap";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { serverHost } from "variables/serverdata";
import { Input } from "reactstrap";
const EmergencyLogs = () => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";
    
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchEmergencyLogs = async () => {
        setLoading(true);
        setError(null);
        try {
            const site = JSON.parse(localStorage.getItem("selectedSite"));
            const response = await fetch(`${serverHost}/emergency_logs/${site.site_uuid}`);
            if (!response.ok) throw new Error("Failed to fetch emergency logs");
            const data = await response.json();
            
            setLogs(data.logs || []);
            
            console.log("Emergency logs fetched");
        } catch (err) {
        setError(err.message);
        } finally {
        setLoading(false);
        }
    };

    const handlePlayRecording = (recordingUrl) => {
        if (recordingUrl) {
        window.open(recordingUrl, "_blank");
        }
    };

    useEffect(() => {
        fetchEmergencyLogs();
    }, []);

    const getCallStatusBadge = (status) => {
        const statusLower = status?.toLowerCase();
        if (statusLower === "answered") return <Badge bg="success">Answered</Badge>;
        if (statusLower === "no answer" || statusLower === "no_answer") return <Badge bg="warning" text="dark">No Answer</Badge>;
        if (statusLower === "busy") return <Badge bg="danger">Busy</Badge>;
        if (statusLower === "failed") return <Badge bg="danger">Failed</Badge>;
        if (statusLower === "voicemail") return <Badge bg="info">Voicemail</Badge>;
        return <Badge bg="secondary">{status || "Unknown"}</Badge>;
    };

    const getEventBadge = (event) => {
        const eventLower = event?.toLowerCase();
        if (eventLower === "911" || eventLower === "emergency") return <Badge bg="danger">911 Emergency</Badge>;
        if (eventLower === "alarm") return <Badge bg="warning" text="dark">Alarm</Badge>;
        if (eventLower === "panic") return <Badge bg="danger">Panic Button</Badge>;
        return <Badge bg="secondary">{event || "Unknown"}</Badge>;
    };

    return (
        <>
        <SimpleHeader name="Emergency Logs" parentName="HUCS" />

        <Container fluid className="mt--6">
            {/* Emergency Logs Table */}
            <Card className={`shadow-sm ${isDark ? "bg-dark text-light border-dark" : ""}`}>
            <Card.Header
                className="d-flex justify-content-between align-items-center flex-wrap"
                style={{
                backgroundColor: isDark ? "#1f2937" : "#f0f0f0",
                color: isDark ? "#e2e8f0" : "#111",
                }}
            >
                <h4 className="mb-2 mb-md-0">
                <Badge bg="danger" className="ms-2" style={{ marginLeft: "0.5rem" }}>
                    {filteredLogs.length} Emergency Events
                </Badge>
                </h4>
                <div className="d-flex gap-2 flex-wrap align-items-center">
                <Button
                    variant="info"
                    size="sm"
                    onClick={fetchEmergencyLogs}
                    disabled={loading}
                >
                    {loading ? "Refreshing..." : "Refresh"}
                </Button>
                </div>
            </Card.Header>

            <Card.Body style={{ padding: 0, backgroundColor: isDark ? "#1f2937" : "#fff" }}>
                {error ? (
                <Alert variant="danger" className="m-3">
                    {error}
                </Alert>
                ) : filteredLogs.length === 0 ? (
                <div
                    className="text-center py-5"
                    style={{ color: isDark ? "#9ca3af" : "#6c757d" }}
                >
                    <h5>No emergency logs found</h5>
                    <p className="mb-0">
                        There are currently no emergency logs.
                    </p>
                </div>
                ) : (
                <div style={{ overflowX: "auto" }}>
                    <Table
                    striped
                    hover
                    responsive
                    bordered
                    className="mb-0"
                    style={{
                        minWidth: "1200px",
                        backgroundColor: isDark ? "#1f2937" : "#fff",
                        color: isDark ? "#e2e8f0" : "#212529",
                    }}
                    >
                    <thead
                        style={{
                        backgroundColor: isDark ? "#1f2937" : "#fff",
                        fontWeight: "bold",
                        color: isDark ? "#e2e8f0" : "#212529",
                        }}
                    >
                        <tr>
                        <th className="text-center">Date</th>
                        <th className="text-center">Time</th>
                        <th className="text-center">Client</th>
                        <th className="text-center">Extension</th>
                        <th className="text-center">Event</th>
                        <th className="text-center">Recording</th>
                        <th className="text-center">Call Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLogs.map((log, index) => (
                        <tr key={index} style={{ color: isDark ? "#e2e8f0" : "#212529" }}>
                            <td className="text-center" style={{ fontWeight: 500 }}>
                            {log.date || "-"}
                            </td>
                            <td className="text-center" style={{ fontFamily: "monospace", fontWeight: 500 }}>
                            {log.time || "-"}
                            </td>
                            <td className="text-center" style={{ fontWeight: 600 }}>
                            {log.client || "-"}
                            </td>
                            <td className="text-center" style={{ fontFamily: "monospace", fontSize: "0.95rem" }}>
                            {log.extension || "-"}
                            </td>
                            <td className="text-center">
                            {getEventBadge(log.event)}
                            </td>
                            <td className="text-center">
                            {log.recording ? (
                                <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handlePlayRecording(log.recording)}
                                >
                                <i className="fas fa-play me-1"></i>
                                Play
                                </Button>
                            ) : (
                                <span style={{ color: isDark ? "#9ca3af" : "#6c757d" }}>
                                No Recording
                                </span>
                            )}
                            </td>
                            <td className="text-center">
                            {getCallStatusBadge(log.call_status)}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </Table>
                </div>
                )}
            </Card.Body>
            </Card>
        </Container>
        </>
    );
};

export default EmergencyLogs;